import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

export const ArenaOpsUsersKpisResponseSchema = z.object({
  totalUsers: z.number().int(),
  fundedUsers: z.number().int(),
  usersHoldingTickets: z.number().int(),
  newUsersInRange: z.number().int(),
  activeUsersInRange: z.number().int(),
  /**
   * Accounts with at least one `DEPOSIT` movement, EVER — a lifetime stock, not
   * a window figure. `fundedUsers` counts who holds money now; this counts who
   * ever brought any, and the gap between them is everyone who deposited and
   * has since spent or withdrawn it.
   */
  everDepositedUsers: z.number().int(),
  /**
   * Rows in `HubUser` under the same cohort filter — the denominator
   * `everDepositedUsers` is read against.
   *
   * Deliberately the WHOLE Hub account base, not the Arena anchor set: the
   * question the tile answers is what share of Cede's users have ever funded an
   * Arena balance, and against the anchor set (accounts that already hold a
   * balance or a ticket) it would be answering a much easier question with a
   * much larger number.
   */
  hubAccountCount: z.number().int(),
  medianBalanceUsdt: ArenaOpsUsdtSchema,
  totalHeldUsdt: ArenaOpsUsdtSchema,
  /**
   * Cash in and cash out over the window, on the **LAG-delta basis** — what actually
   * moved, not what the ledger declared. The two diverge wherever a movement declares an
   * amount the balance never moved, and `SUM(amount)` reports the declared one.
   *
   * The basis is not cosmetic and the UI must state it. Both figures are defensible
   * answers to different questions ("what was declared" vs "what moved"), and the label is
   * the only thing distinguishing them.
   */
  depositedUsdt: ArenaOpsUsdtSchema,
  /** Positive: the magnitude that left balances. */
  withdrawnUsdt: ArenaOpsUsdtSchema,
  /**
   * `withdrawn / deposited`. `"Infinity"` when nothing was deposited — a defined limit,
   * read by `parseRatio`. Not the matchmaking rates' `""`, which marks a rate that does
   * not exist at all.
   */
  withdrawDepositRatio: ArenaOpsUsdtSchema,
});
export type ArenaOpsUsersKpisResponse = z.infer<typeof ArenaOpsUsersKpisResponseSchema>;
